<template lang="html">
    <div id="page__companies" class="center-panel" >
		<md-content md-theme="white" v-loader-overlay="progress">
			<sort-table v-bind:columns="tableColumns" v-model="companies" v-on:create="addCompany" v-on:refresh="getCompanies" v-bind:per-page="perPage" v-bind:total="companiesAmount" link table-id="companies" v-bind:showAddButton="true">
				<template slot="is_default" slot-scope="scope">
					<span>{{ (scope.item.is_default === '1') ? 'Да' : 'Нет' }}</span> 
				</template>

				<template slot="nds" slot-scope="scope">
					<span>{{ (scope.item.nds === '1') ? 'Да' : 'Нет' }}</span> 
				</template>

				<template slot="actions" slot-scope="scope"> 
					<span>{{ scope.item.customer ? scope.item.customer.name : ''}}</span>
				</template>

				<template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
			</sort-table>
		</md-content>
    </div>
</template>
<script>
  import SortTable from "@/components/SortTable";
  import ZIconButton from '@/components/ZIconButton';
  export default {
    components: { SortTable, ZIconButton },
    data() {
      return {
        tableColumns: [
          { label: 'ID',           field: 'id',         sortable: true, default: true,},
          { label: 'Название',     field: 'name',       sortable: true},
          { label: 'ИНН',          field: 'inn',        sortable: true},
          { label: 'По умолчанию', field: 'is_default', sortable: true},
          { label: 'Работает с НДС', field: 'nds', sortable: true},
          { label: '',             field: 'actions' },
        ],
        perPage: 50,
      }
    },
    computed: {
		/**
		 * Флаг загрузки текущего компонента
		 */
		progress() {
			return this.progressObj['get-companies-list'];
		},
		/**
		 * Объект с флагами загрузки
		 */
		progressObj() {
			return this.$store.state.progressObj;
		},
		/**
		 * Список компаний
		 */
		companies() {
			return this.$store.state.companies.companies.map(item => {
				item.routerLink = {name: 'Company', params: {company_id: item.id}};
				return item;
			});
		},
		/**
		 * Количество компаний
		 */
		companiesAmount() {
			return this.$store.state.companies.companies_amount
		},
    },
    watch: {
		'store.state.companies.companies'(newVal) {
			return newVal;
		}
    },
    methods: {
		/**
		 * Инициализация компонента
		 */
		init() {
			this.$store.commit('setTitle', 'Компании');
		},
		/**
		 * Добавление компании
		 */
		addCompany() {
			this.$router.push({ name: 'Company', params: {company_id: 'new'}});
		},
		/**
		 * Получение компании
		 */
		getCompanies(page, count, orderBy, orderType, filter) {
			this.$store.commit('showProgressBar', 'get-companies-list');
			this.init();
			return this.$store.dispatch('companies/getCompanies',{
				page: page, order_by: orderBy, order_type: orderType, count: count, filter: filter
			}).finally(() => this.$store.commit('hideProgressBar', 'get-companies-list'));
		},
		/**
		 * Удаление группы клиентов
		 */
		removeCompany(id) {
			if (!id) return;
			this.$store.commit('showProgressBar', 'get-companies-list');
			this.$store.dispatch('companies/removeCompany', id)
				.then(() => this.$root.$emit('refresh-table', 'companies'))
				.finally(() => this.$store.commit('hideProgressBar', 'get-companies-list'));
		},
		/**
		 * Модальное окно с подтверждением удаления группы
		 */
		onRemove(id) {
			this.$root.$emit(
				'z-alert', 'Вы уверены в удалении Компании', 'Действие необратимо!',
				() => this.removeCompany(id)
			);
		}
    }
  }
</script>



// WEBPACK FOOTER //
// Companies.vue?0639e1cb